import { CircularProgress, styled } from '@mui/material'
import { circularProgressClasses } from '@mui/material/CircularProgress'
import { UserListItemSkeleton } from '$common/user-list-item'
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { openHallProfile } from '$logic/router'
import { useHall } from '$logic/hall/react-hook'
import { toLocale } from '$func/text'
import { HallAppBarCallElement } from '$common/room-app-bar/components/hall-app-bar-call-element'
import { t } from '$i18n'
import { useStartCall } from './react-hooks'
import { HallAvatar } from '$common/avatar'
import { ROOM_APP_BAR_AVATAR_SIZE } from '../conf'
import { useWorkspaceColorByRoomId } from '$logic/workspace'

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.neutral700};
  margin-left: 4px;
  & .${circularProgressClasses.circle} {
    stroke-linecap: round;
  }
`

export function ChannelAppBar({ roomId }: { roomId: string }) {
  const { startingCall, openChooseCallDialog, call, canStartCall } =
    useStartCall({ roomId, hallType: 'CHANNEL' })

  const { entity: hall } = useHall(roomId)
  const backgroundColor = useWorkspaceColorByRoomId(roomId)

  if (!hall) return <UserListItemSkeleton />

  return (
    <RoomAppBarInfo
      backgroundColor={backgroundColor}
      onClick={() => openHallProfile(hall.roomId)}
      avatarElement={
        <HallAvatar
          size={ROOM_APP_BAR_AVATAR_SIZE}
          roomId={hall.roomId}
          withStory
        />
      }
      avatarSrc=""
      primaryText={hall.name}
      secondaryText={`${toLocale(hall.membersCount)} ${t(
        'profile.hall.subscriber',
      )}`}
      verified={hall.verified}
      avatarBackgroundColor={''}
      deleted={!!hall?.deletedAt}
      callElement={
        call || !canStartCall ? null : startingCall ? (
          <StyledCircularProgress size={24} />
        ) : (
          <HallAppBarCallElement
            roomId={roomId}
            onClick={openChooseCallDialog}
            roomType="CHANNEL"
            background={backgroundColor}
          />
        )
      }
    />
  )
}
